/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { UnlockProjectResponse } from '../../models/unlock-project-response';

export interface ProjectsControllerUnlockProject$Params {

/**
 * Project id.
 */
  id: string;
}

export function projectsControllerUnlockProject(http: HttpClient, rootUrl: string, params: ProjectsControllerUnlockProject$Params, context?: HttpContext): Observable<StrictHttpResponse<UnlockProjectResponse>> {
  const rb = new RequestBuilder(rootUrl, projectsControllerUnlockProject.PATH, 'post');
  if (params) {
    rb.path('id', params.id, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<UnlockProjectResponse>;
    })
  );
}

projectsControllerUnlockProject.PATH = '/planning-projects/v1-develop/projects/{id}/unlock';
